import script from "./shop-v1.vue?vue&type=script&setup=true&lang=js"
export * from "./shop-v1.vue?vue&type=script&setup=true&lang=js"

import "./shop-v1.vue?vue&type=style&index=0&id=3a17990e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a17990e"]])

export default __exports__